export default {
  showInvalidDropIndicator(targetElement) {
    const startEvent = new CustomEvent("turbo-frame-loading:start", {
      detail: {
        targetElement,
        identifier: "invalid-action-indicator",
      },
    });

    window.dispatchEvent(startEvent);
  },

  returnToOrigin(draggedData) {
    const originalEvent = draggedData?.event?.detail?.originalEvent;
    if (originalEvent && draggedData.element) {
      originalEvent.from.appendChild(draggedData.element);
    }
  },

  hasExistingExternalResource(element) {
    return !!element.querySelector(".external-flight-info");
  },

  onDragDrop(event) {
    const { draggedItem, dropTarget } = event.detail;

    const targetElement = dropTarget.closest("[data-resource-sku-handle]");

    if (!draggedItem || !targetElement) {
      if (draggedItem) {
        this.returnToOrigin({ element: draggedItem, event });
      }
      return;
    }

    const draggedData = {
      id: draggedItem.dataset.externalPositionId,
      type: draggedItem.dataset.resourceSkuType,
      handle: draggedItem.dataset.resourceSkuHandle,
      resourceType: draggedItem.dataset.resourceSkuType,
      associatedBookingResourceSkuIdFromInverse:
        draggedItem.dataset.associatedBookingResourceSkuIdFromInverse,
      element: draggedItem,
      event,
    };

    const targetData = {
      id: targetElement.dataset.bookingResourceSkuId,
      type: targetElement.dataset.resourceSkuType,
      handle: targetElement.dataset.resourceSkuHandle,
      element: targetElement,
      bookingResourceSkuTransferFlightId:
        targetElement.dataset.bookingResourceSkuTransferFlightId,
      bookingResourceSkuTransferAccommodationId:
        targetElement.dataset.bookingResourceSkuTransferAccommodationId,
      event,
    };

    this.returnToOrigin(draggedData);

    if (
      draggedData.type === "flight" &&
      targetData.type === "transfer" &&
      !this.hasExistingExternalResource(targetElement)
    ) {
      this.onDragDropSuccess(draggedData, targetData);
    } else {
      this.onDragDropFailure(draggedData, targetData);
    }
  },

  onDragDropSuccess(draggedData, targetData) {
    this.constructor.showPickupDropoffModal(draggedData, targetData);
  },

  onDragDropFailure(_draggedData, targetData) {
    this.showInvalidDropIndicator(targetData.element);
  },
};
